//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      default: ""
    },
    icon: {
      default: null
    }
  }
}
